export default class Tailwindcss {
  constructor() {}
  static mergeClasses(defaultClass: string, dynamicClass: string = '') {
    if (!dynamicClass.trim().length) return defaultClass;
    return [dynamicClass, defaultClass || ''].join(' ');
  }
}
